import { GET_APPLICATIONS } from './index';

export const getApplicationsAction = (applications) => ({
    type: GET_APPLICATIONS,
    applications
});